/**
 * Websitebutler CMS Interface
 *
 * Image Utils class.
 */

const ImageUtils = {

    /**
     * @var {String}
     */
    uploadPlaceholderImage: 'data:image/png;base64,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',

    imageBreakpoints: [576, 976],

    getBreakpoints(file, imageWidth) {
        const fileWidth = file.getWidth();
        const breakpoints = [...this.imageBreakpoints].concat([imageWidth]);

        return breakpoints
            .sort((a, b) => a - b)
            .filter((width, pos) =>
                // Remove duplicates
                (!pos || width != breakpoints[pos-1]) &&
                // Only keep numbers
                width != null &&
                // Only keep what's smaller than the desired image width
                (width <= imageWidth) &&
                // Only keep what's less equal the file width
                (!fileWidth || width <= fileWidth)
            )
    },

    generateSrcsetUrls(file, isResponsive, imageWidth, ratio = null) {
        imageWidth = Math.floor(imageWidth);

        if (!isResponsive) {
            return null;
        }

        const getSrcsetSize = (width) => {
            const height = ratio > 0 ? width / ratio : null;
            return file.getImageSize(width, height);
        }

        return this.getBreakpoints(file, imageWidth)
            .map(width => `${getSrcsetSize(width)} ${width}w`)
            .concat(imageWidth*2 <= file.getWidth() ? [`${getSrcsetSize(imageWidth*2)} 2x`] : [])
            .join(', ');
    },

    getSrcset(elm) {
        if (typeof elm === 'undefined' || !elm.hasAttribute) {
            return;
        }
        return elm.hasAttribute('srcset');
    },

    getWidthOfClosestElement(element) {
        // In this case - after traversing up - we assume that the image is currently hidden and return a default width
        if (element == null) {
            return 1024;
        }

        if (element.clientWidth > 0) {
            return element.clientWidth;
        }

        return ImageUtils.getWidthOfClosestElement(element.parentElement);
    },

    swapLazyloadedImage(lazyImage) {
        if (lazyImage.classList.contains('background-image-holder') && lazyImage.dataset.background) {
            lazyImage.style.backgroundImage = lazyImage.dataset.background;
            return;
        }

        if (!lazyImage.dataset.src) {
            return;
        }

        lazyImage.src = lazyImage.dataset.src;

        if (!lazyImage.dataset.srcset) {
            lazyImage.removeAttribute('srcset');
            return;
        }

        // Start building a new srcset for the actual element width
        const srcset = lazyImage.dataset.srcset.split(/\s*,\s*/);
        const elementWidth = ImageUtils.getWidthOfClosestElement(lazyImage);
        const findSmallestSrc = (srcset, minWidth) => srcset.find(
            // Parse width out of USV string: "my-image.jpg 720w" -> 720
            src => parseInt(src.split(' ').reverse()[0]) >= minWidth
        );

        const newSrcset = [
            findSmallestSrc(srcset, elementWidth),
            // Retina image: If we can't find an image that doubles element width, fall "back" to 2x
            findSmallestSrc(srcset, elementWidth * 2) || srcset.find(src => src.indexOf(' 2x') > -1)
        ].filter(Boolean).map(src => src.split(' ')[0]);

        if (newSrcset.length >= 1) {
            lazyImage.src = newSrcset[0];
        }

        if (newSrcset.length === 2) {
            lazyImage.srcset = `${newSrcset[0]} 1x, ${newSrcset[1]} 2x`;
            lazyImage.removeAttribute('sizes');
        } else {
            lazyImage.removeAttribute('sizes');
            lazyImage.removeAttribute('srcset');
        }
    },

};

export default ImageUtils;